import { useState } from "react"

const useFormFields = (initialState) => {
  const [fields, setValues] = useState(initialState)

  return [
    fields,
    (event) => {
      setValues({
        ...fields,
        [event.target.id ? event.target.id : event.target.name]:
          event.target.type === "checkbox" ? event.target.checked : event.target.value,
      })
    },
  ]
}

export default useFormFields
